<template>
    <div>
        <div class="app-container mt-5">
            <div class="page-title mb-3">
                <router-link to="/configuration">
                    <span class="breadcrumb-link">
                        <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                    </span>
                </router-link>
                <v-icon>keyboard_arrow_right</v-icon>
                <span class="breadcrumb-item">
                    <v-icon class="breadcrumb-item-icon">business</v-icon> Ma structure
                </span>
            </div>

            <organism :singleMod="true"></organism>
        </div>
    </div>
</template>

<script>
import Organism from "../../onboard/steps/Organism"
export default {
    name: "BusinessConfig",
    components: { Organism }
}
</script>